import { Component, OnInit } from "@angular/core";

@Component({
  selector: "oz-coming-soon",
  templateUrl: "./coming-soon.component.pug",
})
export class ComingSoonComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
